const setCatType2 = (payload) => {
  return {
    type: "catType2",
    payload,
  };
};

export default setCatType2;
